import { zodResolver } from '@hookform/resolvers/zod';
import { useCallback, useMemo, useRef } from 'react';
import type { Resolver } from 'react-hook-form';

import type { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';

import type { NewTicketFormValuesT } from '../declarations';
import validationSchema from '../validationSchema';

export type UseOpenNewTicketFormResolverParamsT = {
  categoryRows: string[];
  isMultipleTickets: boolean;
  ticketRequestCategories: TicketRequestCategoryI[] | undefined;
};

export function useOpenNewTicketFormResolver({
  categoryRows,
  isMultipleTickets,
  ticketRequestCategories,
}: UseOpenNewTicketFormResolverParamsT): Resolver<NewTicketFormValuesT> {
  const schemaMemo = useMemo(
    () => validationSchema(categoryRows, isMultipleTickets, ticketRequestCategories),
    [categoryRows, isMultipleTickets, ticketRequestCategories]
  );

  const schemaRef = useRef(schemaMemo);
  schemaRef.current = schemaMemo;

  return useCallback<Resolver<NewTicketFormValuesT>>(
    (values, context, options) => zodResolver(schemaRef.current)(values, context, options),
    []
  );
}
